import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";

const Impressum = () => {
  return (
    <div className="min-h-screen bg-[#fafafa] flex flex-col">
      <SEO
        title="Impressum"
        description="Impressum und rechtliche Angaben von Marmoris Studio, Wolfsberg, Kärnten."
        path="/impressum"
      />
      <Header />
      <main
        className="flex-1 section-spacing"
        style={{ paddingTop: "calc(var(--header-height, 6rem) + 3rem)" }}
      >
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <Link
              to="/"
              className="inline-block text-[#4a9da8] hover:text-[#2c4a52] text-sm font-medium mb-8 transition-colors"
            >
              ← Zurück zur Startseite
            </Link>
            <h1 className="text-4xl md:text-5xl font-bold text-[#0f1419] mb-8">
              Impressum
            </h1>

            <p className="text-[#3a3a3a] mb-8">
              Angaben gemäß §5 E-Commerce-Gesetz (ECG), §25 Mediengesetz und Offenlegung gemäß UGB
            </p>

            <div className="prose prose-lg text-[#3a3a3a] space-y-8 prose-headings:break-words prose-p:break-words max-w-none">
              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Marmoris Studio
                </h2>
                <p className="leading-relaxed mb-2">
                  Einzelunternehmen – Werbeagentur
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Inhaber:</strong><br />
                  Jakob Dietmar Riegler
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Unternehmenssitz:</strong><br />
                  Weinleiten 7<br />
                  9400 Wolfsberg<br />
                  Österreich
                </p>
                <p className="leading-relaxed mt-4">
                  <strong>Kontakt:</strong><br />
                  Telefon: <a href="tel:+436649992990" className="text-[#4a9da8] hover:underline">+43 664 9992990</a><br />
                  E-Mail: <a href="mailto:office@marmoris.at" className="text-[#4a9da8] hover:underline">office@marmoris.at</a><br />
                  Website: <a href="https://marmoris.at" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://marmoris.at</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Unternehmensgegenstand
                </h2>
                <p className="leading-relaxed">
                  Dienstleistungen im Bereich Werbung, Design, Markenentwicklung, digitale Kommunikation sowie Entwicklung und Gestaltung von Websites.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Mitglied der Wirtschaftskammerorganisation
                </h2>
                <p className="leading-relaxed mb-2">
                  Mitglied der Wirtschaftskammer Kärnten
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Fachgruppe:</strong><br />
                  Werbung und Marktkommunikation
                </p>
                <p className="leading-relaxed mb-2">
                  <strong>Gewerbe:</strong><br />
                  Werbeagentur
                </p>
                <p className="leading-relaxed">
                  <strong>Gewerbebehörde:</strong><br />
                  Bezirkshauptmannschaft Wolfsberg
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Anwendbare Rechtsvorschriften
                </h2>
                <p className="leading-relaxed mb-2">
                  Gewerbeordnung (GewO)<br />
                  E-Commerce-Gesetz (ECG)<br />
                  Mediengesetz<br />
                  Unternehmensgesetzbuch (UGB)
                </p>
                <p className="leading-relaxed">
                  Abrufbar unter:{" "}
                  <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://www.ris.bka.gv.at</a>
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  UID-Nummer
                </h2>
                <p className="leading-relaxed">
                  ATU82853529
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Medieninhaber und Herausgeber
                </h2>
                <p className="leading-relaxed">
                  Jakob Dietmar Riegler<br />
                  Weinleiten 7<br />
                  9400 Wolfsberg<br />
                  Österreich
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Unternehmensgegenstand der Website
                </h2>
                <p className="leading-relaxed">
                  Information über Dienstleistungen im Bereich Werbung, Design und digitale Kommunikation.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  EU-Streitschlichtung
                </h2>
                <p className="leading-relaxed">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#4a9da8] hover:underline">https://ec.europa.eu/consumers/odr/</a>
                </p>
                <p className="leading-relaxed mt-3">
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
                <p className="leading-relaxed">
                  Wir sind nicht verpflichtet und grundsätzlich nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Haftung für Inhalte
                </h2>
                <p className="leading-relaxed">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß §18 ECG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Haftung für Links
                </h2>
                <p className="leading-relaxed">
                  Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-[#0f1419] mb-3">
                  Urheberrecht
                </h2>
                <p className="leading-relaxed">
                  Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrechtsgesetz. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
                <p className="leading-relaxed mt-3">
                  Verwendete Bilder, Grafiken und Logos unterliegen ebenfalls dem Urheber- und/oder Markenrecht. Die Nutzung, Vervielfältigung oder Weiterverwendung ist ohne ausdrückliche schriftliche Zustimmung des jeweiligen Rechteinhabers nicht gestattet. Marken- und Unternehmenslogos verbleiben im Eigentum der jeweiligen Rechteinhaber.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
